import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppSettings } from './app-settings';

@Injectable()
export class AppSettingsService {
    public settings: AppSettings = new AppSettings();

    constructor(http: HttpClient) {
        http.get<AppSettings>('Api/Settings').subscribe(data => {
            this.settings = data;
        });
    }
}